import { useCallback } from "react";
import {
  ReceivedBseBidDto,
  useEditNegotiationRoundMutation,
  useUpdateBasicSourcingEventMutation,
} from "../../../../../autogen/bff-api";
import { useAppDispatch } from "../../../../../common/redux/hooks";
import { setNegotiationRound, setSourcingEvent } from "../../../../../common/redux/reducers/basicSourcingEventReducer";
import { ProductGroup } from "../../../../../common/types";

export const useSelectProductBid = ({
  bid,
  productId,
  group,
  eventId,
  negotiationRoundId,
}: {
  bid: ReceivedBseBidDto;
  productId: string;
  group: ProductGroup;
  eventId: string;
  negotiationRoundId?: string;
}) => {
  const [updateSourcingEvent, { isLoading: isLoadingEvent }] = useUpdateBasicSourcingEventMutation();
  const [editNegotiationRound, { isLoading: isLoadingRound }] = useEditNegotiationRoundMutation();
  const dispatch = useAppDispatch();

  const selectProductBid = useCallback(async () => {
    if (negotiationRoundId) {
      const round = await editNegotiationRound({
        negotiationId: negotiationRoundId,
        editNegotiationRequest: {
          selectProductBids: [{ productGroupId: group.id, bids: [{ productId, bids: [bid.id] }] }],
        },
      }).unwrap();
      dispatch(setNegotiationRound(round));
    } else {
      const event = await updateSourcingEvent({
        eventId,
        editSourcingEventRequest: {
          selectProductBids: [{ productGroupId: group.id, bids: [{ productId, bids: [bid.id] }] }],
        },
      }).unwrap();
      dispatch(setSourcingEvent(event));
    }
  }, [bid, negotiationRoundId, dispatch, editNegotiationRound, eventId, group, productId, updateSourcingEvent]);

  return { selectProductBid, isLoading: isLoadingEvent || isLoadingRound };
};
